var App = App || {};

App.Activator = (function ($, Vue) {
	"use strict";
	function init(target) {
		target = target || document.getElementById("activation-app");

		if (!target || target.dataset.mounted)
			return;

		target.dataset.mounted = true;

		new Vue({
			el: "#activation-app",
			data: {
				id: String(target.dataset.id),
				code: target.dataset.code,
				password: "",
				confirmPassword: "",
				isSubmitting: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: []
			},
			watch: {
				password: function () { this.clearConfirmError(); },
				confirmPassword: function () { this.clearConfirmError(); }
			},
			methods: {
				clearConfirmError() {
					const confirmEl = this.$refs.form.querySelector("#ConfirmPassword");
					confirmEl.setCustomValidity("");
					this.$refs.form.classList.remove("was-validated");
				},
				scrollToTop() {
					const y = this.$refs.form.getBoundingClientRect().top + window.pageYOffset - 20;
					window.scrollTo({ top: y, behavior: "smooth" });
					if (this.$refs.topAlert) this.$refs.topAlert.focus({ preventScroll: true });
				},
				submitForm(e) {
					const form = this.$refs.form;
					const confirmEl = form.querySelector("#ConfirmPassword");
					if (this.password !== this.confirmPassword) {
						confirmEl.setCustomValidity("Passwords must match.");
					}
					if (!form.checkValidity()) {
						form.classList.add("was-validated");
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];

					$.ajax({
						url: "/api/registration/activate",
						method: "POST",
						contentType: "application/json",
						data: JSON.stringify({
							id: this.id,
							code: this.code,
							password: this.password
						})
					})
						.done(resp => {
							if (resp && resp.success) {
								this.isComplete = true;
								this.alertMessage = "";
								this.alertErrors = [];
								this.scrollToTop();
							} else {
								this.alertMessage = (resp && resp.message) || "Activation failed.";
								this.alertErrors = (resp && resp.data && resp.data.errors || [])
									.map(e => e.description).filter(Boolean);
								form.classList.add("was-validated");
								this.scrollToTop();
							}
						})
						.fail(() => {
							this.alertMessage = "Activation failed.";
							form.classList.add("was-validated");
							this.scrollToTop();
						})
						.always(() => {
							this.isSubmitting = false;
						});
				}
			}
		});
	}

	return {
		init: init
	};

})(jQuery, Vue);

App.Activator.init();